import { render, staticRenderFns } from "./fixed_asset_borrow.vue?vue&type=template&id=d38e1724&scoped=true"
import script from "./fixed_asset_borrow.vue?vue&type=script&lang=js"
export * from "./fixed_asset_borrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38e1724",
  null
  
)

export default component.exports